'use client';
import React from 'react';
import styled from '@benzinga/themetron';
// import { OfferingsCarousel } from '@benzinga/alternative-investments';
import { AltOffering, ingressAltOfferings, IngressAltOffering } from '@benzinga/alts-manager';
import Hooks from '@benzinga/hooks';

// import LazyLoad from 'react-lazyload';

export interface ListingPreviewBlockProps {
  attrs?: any;
  products: IngressAltOffering[];
}

const OfferingsGrid = React.lazy(() =>
  import('@benzinga/alternative-investments').then(module => {
    return { default: module.OfferingsGrid };
  }),
);

const OfferingsCarousel = React.lazy(() =>
  import('@benzinga/alternative-investments').then(module => {
    return { default: module.OfferingsCarousel };
  }),
);

const OfferingSingleWide = React.lazy(() =>
  import('@benzinga/alternative-investments').then(module => {
    return { default: module.OfferingSingleWide };
  }),
);

interface OfferingsCarouselInteface {
  fixedWidth?: number;
  perPage: number;
  breakpoints: any;
}

const calculatePerPage = (width, variant) => {
  if (width <= 500) return 1;
  else if (width <= 720) return 2;
  else if (variant === 'featured') return 3;
  else return 2;
};

export const ListingPreviewBlock: React.FC<ListingPreviewBlockProps> = ({ attrs, products }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { width } = Hooks.useWindowSize();
  // const compact = width <= 500;

  const ingressProducts = ingressAltOfferings(products) as unknown as AltOffering[];

  const display = attrs.data.display ?? 'default';
  const variant = attrs.data.layout ?? 'default';
  const perPage = calculatePerPage(width, variant); // width <= 500 ? 1 : width <= 720 ? 2 : variant === 'featured' ? 3 : 2;

  if (display === 'grid') {
    return <OfferingsGrid offerings={ingressProducts} variant={variant} />;
  } else if (display === 'single-wide') {
    return <OfferingSingleWide offerings={ingressProducts} />;
  }

  const breakpoints = {
    750: {
      perPage: 1,
    },
    900: {
      perPage: 1.5,
    },
  };

  if (variant === 'featured') {
    breakpoints[600] = { destroy: true };
  }

  const options: OfferingsCarouselInteface = {
    breakpoints: breakpoints,
    fixedWidth: 320,
    perPage: perPage,
  };

  if (variant === 'featured') delete options['fixedWidth'];

  return (
    <Container className="block listing-preview-block" ref={ref}>
      <OfferingsCarousel
        items={ingressProducts}
        options={options}
        showEmailCapture={attrs.data.show_email_capture}
        title={attrs.data.title}
        variant={variant}
      />
    </Container>
  );
};

export const Container = styled.div``;
